module.exports = __webpack_public_path__ + "static/media/JO.c8cfe14d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/JO.svg
// module id = 2180
// module chunks = 7